import script from "./CustomerReportingExport.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerReportingExport.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerReportingExport.vue?vue&type=style&index=0&id=3af88e64&lang=css"

const __exports__ = script;

export default __exports__